import { render, staticRenderFns } from "./juriesEdition.vue?vue&type=template&id=5be24d6d"
import script from "./juriesEdition.vue?vue&type=script&lang=js"
export * from "./juriesEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports